module.exports = __webpack_public_path__ + "img/border_Ellipse_3D.f4defa7d.svg";